import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { history } from './Utils/utils';
import { reducer as auth } from './Containers/LoginPage/reducer';
import { reducer as startup } from './Redux/StartupRedux';
import { reducer as nav } from './Redux/NavRedux';
import { reducer as errors } from './Redux/ErrorsRedux';
import { reducer as plan } from './Redux/PlanRedux';

import { reducer as onBoarding } from './Containers/Onboarding/reducer';
import { reducer as users } from './Containers/User/reducer';
import { reducer as setting } from './Containers/SettingPage/reducer';
import { reducer as dashboard } from './Containers/DashboardPage/reducer';
import { reducer as excel } from './Containers/ExcelPage/reducer';

import { reducer as portfolioAdmin } from './Containers/UsersPageAdmin/reducer';
import { reducer as leads } from './Containers/LeadsPageAdmin/reducer';


export const reducers = combineReducers({
  auth,
  nav,
  errors,
  plan,
  startup,
  onBoarding,
  users,
  setting,
  dashboard,
  excel,
  portfolioAdmin,
  leads,

  router: connectRouter(history),
});

export default reducers;
